export const HIDE_BADGE_PLAN_TYPES = [
  'plan_agency',
  'plan_team',
  'plan_teamperseat',
  'plan_team3seats',
  'plan_teamperseat2',
]
